import { render, staticRenderFns } from "./donor-sign-up-form.vue?vue&type=template&id=56c5819a&scoped=true&"
import script from "./donor-sign-up-form.vue?vue&type=script&lang=js&"
export * from "./donor-sign-up-form.vue?vue&type=script&lang=js&"
import style0 from "./donor-sign-up-form.vue?vue&type=style&index=0&id=56c5819a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c5819a",
  null
  
)

export default component.exports